import { call, put, all, takeLatest, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  getCoverageListApi,
  getCoverageListByTypePDVApi,
} from 'services/openClaimService';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';
import { ApplicationState } from 'store/store.inteface';
import { setCoverageList, setCoverageListByTypePDV } from './actions';
import { Coverage, COVERAGE_TYPES } from './types';

export function* setCoverageListSaga() {
  // yield take(OPENCLAIM_TYPES.GET_COVERAGELIST_REQUEST);
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<Coverage[]>> = yield call(
      getCoverageListApi,
      cpId,
      stores[0]?.code,
    );
    yield put(setCoverageList(data.response));
  } catch (err) {
    console.log(err);
  }
}

export function* setCoverageListByTypePDVSaga({
  payload,
}: SagasAction<string>) {
  try {
    const { stores, cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data } = yield call(
      getCoverageListByTypePDVApi,
      payload,
      cpId,
      stores[0].code,
    );
    yield put(setCoverageListByTypePDV(data.response));
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeLatest(COVERAGE_TYPES.GET_COVERAGELIST_REQUEST, setCoverageListSaga),
  takeLatest(
    COVERAGE_TYPES.GET_COVERAGELIST_BY_TYPE_PDV_REQUEST,
    setCoverageListByTypePDVSaga,
  ),
]);
